export default __webpack_public_path__ + "static/media/info_5.18a79b73.png";